(function () {
  // ── Add-to-Cart toast notification ──────────────────────────────────────────
  function showCartToast(title) {
    // Remove any existing toast first
    var existing = document.getElementById('lb-cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'lb-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="lb-toast__icon">&#10003;</span>' +
      '<span class="lb-toast__msg"><strong>' + title + '</strong> added to cart</span>' +
      '<a href="/cart" class="lb-toast__link">View Cart</a>';

    document.body.appendChild(toast);

    // Trigger entrance animation
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('lb-toast--visible');
      });
    });

    // Auto-dismiss after 3.5 s
    setTimeout(function () {
      toast.classList.remove('lb-toast--visible');
      toast.addEventListener('transitionend', function () { toast.remove(); }, { once: true });
    }, 3500);
  }

  // ── Delegate click events for all ATC buttons ────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target?.closest('.product-card-atc');
    if (!btn) return;

    var variantId = btn.dataset.variantId;
    var productTitle = btn.dataset.productTitle || 'Item';
    if (!variantId) return;

    // Optimistic UI feedback
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function () {
        btn.textContent = '✓ Added';
        showCartToast(productTitle);

        // Fetch the real cart total and fire the theme's native cart:update event
        // so cart-icon.js updates the bubble count correctly.
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            // Temporarily suppress the cart drawer auto-open triggered by cart:update.
            // cart-icon.js listens to the same event and will still update the count.
            var drawer = document.querySelector('cart-drawer-component');
            var hadAutoOpen = drawer && drawer.hasAttribute('auto-open');
            if (hadAutoOpen) drawer?.removeAttribute('auto-open');

            var event = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: {
                  itemCount: cart.item_count,
                  source: 'product-card-atc'
                }
              }
            });
            document.dispatchEvent(event);

            // Restore auto-open so normal in-page ATC buttons still open the drawer
            if (hadAutoOpen) drawer?.setAttribute('auto-open', '');
          });

        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        showCartToast('Could not add item — please try again.');
      });
  });
})();
